import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { usersStoreModule } from '@/store/users.store';
import { ordersStoreModule } from '@/store/orders.store';
import { companiesStoreModule } from '@/store/companies.store';
import { templatesStoreModule } from '@/store/item-details-templates.store';

export const mutations = {
  LOADING_START(state: any) {
    Vue.set(state, 'isLoading', true);
  },
  LOADING_FINISH(state: any) {
    Vue.set(state, 'isLoading', false);
  },
  SET_ALERT_MESSAGE(state: any, message: string) {
    Vue.set(state, 'alert', {
      message: message
    });
  },
  SHOW_CONFIRMATION(
      state: any,
      {message, payload, action}: { message: string, payload: any, action: string }
  ) {
    Vue.set(state, 'confirmation', {
      message,
      isVisible: true,
      payload,
      action
    });
  },
  HIDE_CONFIRMATION(state: any) {
    Vue.set(state, 'confirmation', {
      message: '',
      isVisible: false
    });
  }
};

export const actions = {
  SET_ALERT_MESSAGE({commit}: any, message: string) {
    commit('SET_ALERT_MESSAGE', message);
  },
  HIDE_CONFIRMATION({commit}: any) {
    commit('HIDE_CONFIRMATION');
  }
};

export interface RootState {
  users?: any
  isLoading: boolean,
  alert: {
    message: string
  },
  confirmation: {
    message: string,
    isVisible: boolean,
    payload: any,
    action: string
  }
}

export const rootState: RootState = {
  isLoading: false,
  alert: {
    message: ''
  },
  confirmation: {
    message: '',
    isVisible: false,
    payload: {},
    action: ''
  }
};

Vue.use(Vuex);

const rootStore: StoreOptions<RootState> = {
  modules: {
    orders: ordersStoreModule,
    users: usersStoreModule,
    companies: companiesStoreModule,
    templates: templatesStoreModule,
  },
  state: rootState,
  mutations,
  actions
};

export default new Vuex.Store<RootState>(rootStore);

